import { useCart } from '../../../state/cart';
import './UpdateErrorsModal.css';
import { useEffect, useState } from 'react';
import { Modal } from '../../../components/Modal/Modal';
import { ContentCard } from '../../../components/ContentCard/ContentCard';
import { Icon, close } from '../../../components/Icon/Icon';
export const UpdateErrorsModal = (): JSX.Element => {
	const { cart } = useCart();
	const [updateNotices, setUpdateNotices] = useState<string[]>([]);
	const showUpdateNotices = updateNotices.length > 0;

	useEffect(() => {
		let notices: string[] = [];
		if (cart.updateWarnings.length > 0) notices.push(...cart.updateWarnings);
		if (cart.updateErrors.length > 0) notices.push(...cart.updateErrors);
		if (notices.length > 0) setUpdateNotices(notices);
	}, [cart.updateWarnings, cart.updateErrors]);

	return (
		<>
			<Modal className="update-errors-modal" show={showUpdateNotices} onDismiss={() => setUpdateNotices([])}>
				<ContentCard className="content">
					<a className="discard" onClick={() => setUpdateNotices([])}>
						<Icon shape={close} />
					</a>
					<ul>
						{updateNotices.map((m, i) => (
							<li key={m + i}>{m}</li>
						))}
					</ul>
				</ContentCard>
			</Modal>
		</>
	);
};
